import EnMake from './en/comment-automatiser-vos-taches-avec-make';
import EnExportImport from './en/comment-exporter-et-importer-un-modele-de-donnees';
import EnDashboards from './en/comment-creer-des-tableaux-de-bord';
import EnCreateModel from './en/comment-creer-votre-modele-de-donnees';
import EnImportData from './en/comment-importer-vos-donnees-dans-compozz';
import EnFields from './en/les-differents-types-de-champs';
import EnRights from './en/gestion-droit-utilisateur';
import FrMake from './fr/comment-automatiser-vos-taches-avec-make';
import FrExportImport from './fr/comment-exporter-et-importer-un-modele-de-donnees';
import FrDashboards from './fr/comment-creer-des-tableaux-de-bord';
import FrCreateModel from './fr/comment-creer-votre-modele-de-donnees';
import FrImportData from './fr/comment-importer-vos-donnees-dans-compozz';
import FrFields from './fr/les-differents-types-de-champs';
import FrRights from './fr/gestion-droit-utilisateur';
import FrIntroduction from './fr/introduction';
import EnIntroduction from './en/introduction';
import EnFormules from './en/formules';
import FrFormules from './fr/formules';
import FrVues from './fr/vues';
import EnVues from './en/vues';
import EnN8n from './en/automatisez-vos-taches-avec-n8n';
import FrN8n from './fr/automatisez-vos-taches-avec-n8n';
export type ArticleLoader = () => Promise<{ default: React.ComponentType<any> }>;

export type ArticlesByLang = Record<string, Record<string, ArticleLoader>>;

// Registry of manual articles by language and slug.
// Extend this map when adding new files under ./fr or ./en
export const articleLoadersByLang: ArticlesByLang = {
  en: {
    'comment-automatiser-vos-taches-avec-make': () => import('./en/comment-automatiser-vos-taches-avec-make'),
    'comment-exporter-et-importer-un-modele-de-donnees': () => import('./en/comment-exporter-et-importer-un-modele-de-donnees'),
    'comment-creer-des-tableaux-de-bord': () => import('./en/comment-creer-des-tableaux-de-bord'),
    'comment-creer-votre-modele-de-donnees': () => import('./en/comment-creer-votre-modele-de-donnees'),
    'comment-importer-vos-donnees-dans-compozz': () => import('./en/comment-importer-vos-donnees-dans-compozz'),
    'les-differents-types-de-champs': () => import('./en/les-differents-types-de-champs'),
    'gestion-droit-utilisateur': () => import('./en/gestion-droit-utilisateur'),
    'formules': () => import('./en/formules'),
    'introduction': () => import('./en/introduction'),
    'vues': () => import('./en/vues'),
    'automatisez-vos-taches-avec-n8n': () => import('./en/automatisez-vos-taches-avec-n8n'),
  },
  fr: {
    'comment-automatiser-vos-taches-avec-make': () => import('./fr/comment-automatiser-vos-taches-avec-make'),
    'comment-exporter-et-importer-un-modele-de-donnees': () => import('./fr/comment-exporter-et-importer-un-modele-de-donnees'),
    'comment-creer-des-tableaux-de-bord': () => import('./fr/comment-creer-des-tableaux-de-bord'),
    'comment-creer-votre-modele-de-donnees': () => import('./fr/comment-creer-votre-modele-de-donnees'),
    'comment-importer-vos-donnees-dans-compozz': () => import('./fr/comment-importer-vos-donnees-dans-compozz'),
    'les-differents-types-de-champs': () => import('./fr/les-differents-types-de-champs'),
    'gestion-droit-utilisateur': () => import('./fr/gestion-droit-utilisateur'),
    'formules': () => import('./fr/formules'),
    'introduction': () => import('./fr/introduction'),
    'vues': () => import('./fr/vues'),
    'automatisez-vos-taches-avec-n8n': () => import('./fr/automatisez-vos-taches-avec-n8n'),
  },
};



export const articleComponentsByLang: Record<'en'|'fr', Record<string, React.ComponentType<any>>> = {
  en: {
    'comment-automatiser-vos-taches-avec-make': EnMake,
    'comment-exporter-et-importer-un-modele-de-donnees': EnExportImport,
    'comment-creer-des-tableaux-de-bord': EnDashboards,
    'comment-creer-votre-modele-de-donnees': EnCreateModel,
    'comment-importer-vos-donnees-dans-compozz': EnImportData,
    'les-differents-types-de-champs': EnFields,
    'gestion-droit-utilisateur': EnRights,
    'introduction': EnIntroduction,
    'formules': EnFormules,
    'vues': EnVues,
    'automatisez-vos-taches-avec-n8n': EnN8n,
  },
  fr: {
    'comment-automatiser-vos-taches-avec-make': FrMake,
    'comment-exporter-et-importer-un-modele-de-donnees': FrExportImport,
    'comment-creer-des-tableaux-de-bord': FrDashboards,
    'comment-creer-votre-modele-de-donnees': FrCreateModel,
    'comment-importer-vos-donnees-dans-compozz': FrImportData,
    'les-differents-types-de-champs': FrFields,
    'gestion-droit-utilisateur': FrRights,
    'introduction': FrIntroduction,
    'formules': FrFormules,
    'vues': FrVues,
    'automatisez-vos-taches-avec-n8n': FrN8n,
  },
};



